<template>
  <div class="qualification-wrapper">
    <h3 class="qualification-wrapper-title">Qualifications</h3>
    <div class="tabs">
      <div class="tab" :class="{ active: tab == 'edu' }" @click="tab = 'edu'">
        Education
      </div>
      <div class="tab" :class="{ active: tab == 'trai' }" @click="tab = 'trai'">
        Trainings
      </div>
      <div class="tab" :class="{ active: tab == 'cer' }" @click="tab = 'cer'">
        Certification
      </div>
    </div>
    <div class="tab-body">
      <Education
        :id="id"
        :company_id="company_id"
        v-if="tab == 'edu'"
      ></Education>
      <Trainings
        :id="id"
        :company_id="company_id"
        v-if="tab == 'trai'"
      ></Trainings>
      <Certification
        :id="id"
        :company_id="company_id"
        v-if="tab == 'cer'"
      ></Certification>
    </div>
  </div>
</template>
<script>
import Education from "./Qualification/Education.vue";
import Trainings from "./Qualification/Trainings.vue";
import Certification from "./Qualification/Certification.vue";

export default {
  name: "Qualification",
  components: {
    Education,
    Trainings,
    Certification,
  },
  props: {
    company_id: {
      type: Number,
      default: null,
    },
    id: {
      type: Number,
      default: null,
    },
  },
  data: () => {
    return {
      tab: "edu",
    };
  },
  mounted() {},
  computed: {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.qualification-wrapper {
  background: #fff;
  padding: 17px 0px;
  border-radius: 5px;
  @media (min-width: 300px) and (max-width: 630px) {
    padding: 0px 0px;
  }
  .qualification-wrapper-title {
    font-size: 18px;
    padding-bottom: 18px;
    padding-right: 20px;
    padding-left: 20px;
    margin: 0px;
    @media (min-width: 300px) and (max-width: 630px) {
      font-size: 16px !important;
    }
  }
  .tabs {
    display: grid;
    grid-template-columns: 33.3% 33.3% 33.3%;
    .tab:nth-child(1) {
      border-top-left-radius: 0px;
      @media (min-width: 300px) and (max-width: 630px) {
        border-top-left-radius: 0px;
      }
    }
    .tab:nth-child(3) {
      border-top-right-radius: 0px;
      @media (min-width: 300px) and (max-width: 630px) {
        border-top-left-radius: 0px;
      }
    }
    .tab {
      background: #cccccc;
      height: 55px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: 500ms ease-in-out;
      color: #000;
      &.active {
        background: #f7f7f7;
        color: #1ba5a4;

        transition: 500ms ease-in-out;
        border-bottom: 2px solid #1ba5a4;
      }
      &:hover {
        color: #1ba5a4;
      }
    }
  }
  .tab-body {
    background: #f7f7f7;
  }
}
</style>